import React from 'react';
import BaseVegetableCharacter from './BaseVegetableCharacter';

const AubergineCharacter = (props) => {
    const primaryColor = "#7b1fa2"; // Eggplant purple
    const secondaryColor = "#6a1b9a"; // Darker purple

    const renderAubergineBody = () => (
        <>
            {/* Aubergine/Eggplant Body - elongated pear shape */}
            <group>
                {/* Bottom bulbous part */}
                <mesh castShadow position={[0, -0.1, 0]}>
                    <sphereGeometry args={[0.25, 16, 16]} />
                    <meshStandardMaterial color={primaryColor} />
                </mesh>

                {/* Top narrower part */}
                <mesh castShadow position={[0, 0.15, 0]}>
                    <cylinderGeometry args={[0.15, 0.25, 0.3, 16]} />
                    <meshStandardMaterial color={primaryColor} />
                </mesh>

                {/* Shiny highlight effect */}
                <mesh castShadow position={[0.1, 0, 0.1]}>
                    <sphereGeometry args={[0.1, 16, 16]} />
                    <meshStandardMaterial color="#9c27b0" />
                </mesh>
            </group>

            {/* Stem and calyx (the green leafy top) */}
            <group position={[0, 0.3, 0]}>
                {/* Stem */}
                <mesh castShadow>
                    <cylinderGeometry args={[0.02, 0.02, 0.1, 8]} />
                    <meshStandardMaterial color="#4caf50" />
                </mesh>

                {/* Calyx (star-shaped leafy top) */}
                {[...Array(5)].map((_, i) => {
                    const angle = (i / 5) * Math.PI * 2;
                    const x = Math.sin(angle) * 0.1;
                    const z = Math.cos(angle) * 0.1;
                    return (
                        <mesh key={i} position={[x, -0.05, z]} rotation={[0.6, angle, 0]} castShadow>
                            <coneGeometry args={[0.05, 0.1, 5]} />
                            <meshStandardMaterial color="#388e3c" />
                        </mesh>
                    );
                })}
            </group>
        </>
    );

    return (
        <BaseVegetableCharacter
            {...props}
            renderBody={renderAubergineBody}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
        />
    );
};

export default AubergineCharacter;
